// The simulator button sits beside each age group's core-drill heading, far from the island's
// own mount point, and the page carries no inline handlers (CSP). One delegated listener turns
// a `data-routine-open="U8"` click into the event the island listens for.
export function initRoutineOpen(root = document) {
  root.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-routine-open]');
    if (!button) return;
    event.preventDefault();
    root.dispatchEvent(
      new CustomEvent('routine:open', { detail: { group: button.dataset.routineOpen } })
    );
  });
}
